// extracted by mini-css-extract-plugin
export default {"modalWindowBottom":"modal-bottom_modalWindowBottom__Cihsf"};